import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllAuditDispatchStatisticsReport from "./components/ListAllAuditDispatchStatisticsReport";

export default function AuditDispatchStatisticsReportTable() {
    const { translate } = useLang();
    
    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('Dispatch statistics')}`} />
            <ListAllAuditDispatchStatisticsReport />
        </>
    )
}